import React, { lazy, Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { useDynamicTheme } from './Hooks/Theme/useDynamicTheme'
import './style-isolation.css'

const AppProviders = lazy(
  () => import(/* webpackChunkName: "app-providers" */ './AppProviders')
)

const App: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { theme } = useDynamicTheme()

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Suspense fallback={<></>}>
          <AppProviders />
        </Suspense>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
